/* Oche - typed WebSocket protocol shared by the Durable Object and the SPA. */
import { z } from 'zod';

export const WsScoreMessage = z.object({
  type: z.literal('score'),
  playerId: z.string().uuid(),
  newScore: z.number().int(),
  delta: z.number().int(),
});

export const WsStatusMessage = z.object({
  type: z.literal('status'),
  status: z.enum(['active', 'completed']),
});

export const WsHelloMessage = z.object({ type: z.literal('hello'), sessionId: z.string().uuid() });

export const WsServerMessage = z.discriminatedUnion('type', [WsScoreMessage, WsStatusMessage]);
export type WsServerMessage = z.infer<typeof WsServerMessage>;

export const WsClientMessage = z.discriminatedUnion('type', [
  WsHelloMessage,
  z.object({ type: z.literal('simulate'), enabled: z.boolean() }),
]);
export type WsClientMessage = z.infer<typeof WsClientMessage>;
